function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useRefCallback, useSingleton } from '@bydesign-ui/hooks';
import { useCallback, useEffect } from 'react';
import { DragMask } from '../../../models/drag-mask';
import { useContainer, useElementPosition } from '@bydesign-ui/hooks';
import { useDrag } from '../../drag';
export function useDragMask(elem, options) {
  var draggable = options.draggable,
      data = options.data,
      onChange = options.onChange,
      onEnd = options.onEnd,
      onStart = options.onStart,
      extra = _objectWithoutProperties(options, ["draggable", "data", "onChange", "onEnd", "onStart"]);

  var mask = useSingleton(function () {
    return new DragMask();
  });
  var getContainer = useContainer(elem);
  var onChangeCallback = useRefCallback(onChange);
  var onEndCallback = useRefCallback(onEnd);
  var onStartCallback = useRefCallback(onStart);
  var onDragStart = useCallback(function (e) {
    mask.updateStartPos(e);
  }, []);
  var onDragging = useCallback(function (e) {
    mask.updateEndPos(e);
  }, []);
  var onDragEnd = useCallback(function (e) {
    mask.stopDrag(e);
  }, []);
  mask.updateOptions(extra);
  useDrag(elem, {
    draggable: draggable,
    data: data,
    onDragEnd: onDragEnd,
    onDragging: onDragging,
    onDragStart: onDragStart
  });
  useElementPosition(elem, function () {
    return true;
  }, function (rect) {
    mask.updateBoxRect(rect);
  }, {});
  useEffect(function () {
    mask.updateContainer(getContainer());
  });
  useEffect(function () {
    mask.addListener('change', onChangeCallback);
    mask.addListener('start', onStartCallback);
    mask.addListener('end', onEndCallback);
    return function () {
      mask.removeListener('change', onChangeCallback);
      mask.removeListener('start', onStartCallback);
      mask.removeListener('end', onEndCallback);
    };
  }, []);
  return mask;
}